<template lang="pug">
  .DisclaimerDisclosure.disclosure
    slot
    a(
      :class="linkClass",
      href="/",
      @click.prevent="openModalDisclaimerDisclosure()",
    )
      slot(name="linkName")
</template>

<script>
import { openModalDisclaimerDisclosure } from 'Components/ModalDisclaimerDisclosure';

export default {
  name: 'DisclaimerDisclosure',
  props: {
    linkClass: String,
  },
  methods: {
    openModalDisclaimerDisclosure,
  },
};
</script>
